"use client";

import { useEffect, useState, type ReactNode } from "react";
import { cn } from "../lib/utils";

/**
 * The command palette shortcut renders before the platform is known, so the
 * server output assumes the macOS glyph and swaps to `Ctrl` after hydration
 * instead of rendering nothing (which would shift the layout).
 */
export function useModifierKeyLabel() {
  const [label, setLabel] = useState("⌘");
  useEffect(() => {
    if (!/Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)) setLabel("Ctrl");
  }, []);
  return label;
}

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        "inline-flex h-4 min-w-4 items-center justify-center rounded border border-line-strong px-1",
        "font-mono text-[10px] font-normal leading-none text-fg-subtle",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
